import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Search as CleanSearch } from './../../components';

const Search: React.FC<React.ComponentPropsWithoutRef<typeof CleanSearch> & {
  name?: string;
  error?: boolean;
}> = ({ name, ...props }) => {
  const { control } = useFormContext<any>();

  if (!name) {
    throw new Error('Name not provided');
  }

  return <Controller name={name} control={control} render={({ field }) => <CleanSearch {...field} {...props} />} />;
};

export default Search;
